import { CartEffects } from '../effects/cart.effect';

export const effects: any[] = [CartEffects];

export * from './cart.effect';
